export { PersonNameColumnComponent } from './person-name-column.component';
